import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import { setToken, getToken} from '@/request/util.js'
import store from './store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: "/index",
      children:[
        {
          path: 'index',
          name: 'index',
          component: () => import('./views/home/index.vue')
        },
        {
          path: 'farm',
          name: 'farm',
          meta: {
            requireAuth:true,
          },
          component: () => import('./views/farm/index.vue')
        }, {
          path: 'agronomy',
          name: 'agronomy',
          component: () => import('./views/agronomy/index.vue')
        }, {
          path: 'my',
          name: 'my',
          component: () => import('./views/my/index.vue')
        },
      ]
    },    
    {
      path: '/plantingSite',
      name: 'plantingSite',
      component: () => import('./views/otherPage/plantingSite')
    },
    {
      path: '/soilFormula',
      name: 'soilFormula',
      component: () => import('./views/otherPage/soilFormula'),
      children:[

      ]
    },
    {
      path:'/newsList',
      name: 'newsList',
      component:()=> import('./views/otherPage/newsList')
    },
    {
      path: '/baseList',
      name: 'baseList',
      component: () => import('./views/otherPage/baseList')
    },
    {
      path: '/articleDetails',
      name: 'articleDetails',
      component: () => import('./views/otherPage/articleDetails')
    },
    {
      path: '/traceability',
      name: 'traceability',
      component: () => import('./views/otherPage/traceability')
    },
    {
      path: '/dataStatistics',
      name: 'dataStatistics',
      component: () => import('./views/otherPage/dataStatistics')
    },
    {
      path: '/historyData',
      name: 'historyData',
      component: () => import('./views/otherPage/historyData')
    },
    {
      path: '/fertilizerPro',
      name: 'fertilizerPro',
      component: () => import('./views/agronomy/fertilizerPro')
    },
    {
      path: '/collection',
      name: 'collection',
      component: () => import('./views/agronomy/collection')
    },
    {
      path: '/position',
      name: 'position',
      component: () => import('./views/otherPage/position')
    },
    {
      path: '/forecast',
      name: 'forecast',
      component: () => import('./views/otherPage/forecast')
    },
    {
      path: '/scan',
      name: 'scan',
      component: () => import('./views/otherPage/scan')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/user/login')
    },
    {
      path: '/reg',
      name: 'reg',
      component: () => import('./views/user/reg')
    },
    {
      path: '/weatherCount/',
      name: 'weatherCount',
      component: () => import('./views/farm/weatherCount')
    },
    {
      path: '/soilCount/',
      name: 'soilCount',
      component: () => import('./views/farm/soilCount')
    }


  ]
})


const LOGIN_PAGE_NAME = 'login'

router.beforeEach((to, from, next) => {
  
  switch (to.name) {
    case 'index':
      store.commit('setMeanIndex',0)
      
      break;
    case 'farm':
      store.commit('setMeanIndex', 1)
      break;
    case 'agronomy':
      store.commit('setMeanIndex', 2)
      break;
    case 'my':
      store.commit('setMeanIndex', 3)
      break;
    
    default:
      break;
  }



  const token = getToken()
  if (!token && to.name == 'farm' || !token && to.name == 'my') {
    // 未登录且要跳转的页面是农场页面
    next({
      name: LOGIN_PAGE_NAME, // 跳转到登录页,
      query:{
        redirect:to.path
      }
    })
  } else if (!token && to.name === LOGIN_PAGE_NAME) {    
    // 未登陆且要跳转的页面是登录页
    next() // 跳转
  } else if (token && to.name === LOGIN_PAGE_NAME) {    
    
    // 已登录且要跳转的页面是登录页
    next({
      path: 'index' // 跳转到homeName页
    })
  }else{    
    if (store.state.hasGetInfo) {
        next()
    } else {
      store.dispatch('getUserInfo').then(() => {
        next()
      }).catch(() => {
        setToken('')
        next({
          name: 'login'
        })
      })
    }
  }
})

export default router
